<template>
    <btn
        primary
        @click="openSelfieState"
    >
        {{ buttonCopy }}

        <beta-badge
            v-if="aiActiveState === aiStates.default && !fromSwitchModal"
            :is-in-button="true"
        />
    </btn>
</template>

<script>
    import Btn from '../ui/Btn.vue';
    import BetaBadge from './BetaBadge.vue';

    export default {
        components: {
            Btn,
            BetaBadge,
        },

        props: {
            isErrorState: {
                type: Boolean,
                default: false,
            },

            fromSwitchModal: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            aiStates() {
                return this.$store.state.aiStates;
            },

            aiActiveState() {
                return this.$store.state.aiActiveState;
            },

            buttonCopy() {
                return this.isErrorState ? this.$t('AI_SELFIE_RETAKE') : this.$t('AI_SELFIE');
            },
        },

        methods: {
            openSelfieState() {
                this.$store.state.customizer.mainController.trackAction({
                    action: 'ai-selfie-take',
                });

                // Open AI modal if button was clicked from the switch pop modal
                if (this.fromSwitchModal) {
                    this.loadOtherPop();
                    this.$store.dispatch('showSwitchPopModal', false);
                    this.$store.dispatch('showAiModal', true);
                }
                this.$store.dispatch('setAiActiveState', this.aiStates.selfie);
                this.$store.dispatch('resetAiStates');
            },

            loadOtherPop() {
                const current = this.$store.state.customizer.viewController;
                const notCurrent = this.$store.getters.popControllers.find((x) => x !== current);
                const startGroup = notCurrent.blueprint.groups.find((g) => g.custom && g.custom['fun-start-group'] === 'true');

                this.$store.dispatch('selectPop', notCurrent);
                this.$store.dispatch('showGroup', startGroup);
            },
        },
    };
</script>
